<template>
  <div>
    <label class="block text-sm font-bold">
      <slot/>
      <span v-if="required" class="text-secondary">
        *
      </span>
    </label>
    <editor-content
      :editor="editor"
      class="appearance-none border-2 border-primary-medium rounded py-2 px-3 text-primary-medium text-sm leading-tight"
    />
    <editor-menu-bar v-slot="{ commands, isActive }" :editor="editor">
      <div class="add-comment--style mt-3">
        <button
          class="add-comment--style--icon"
          type="button"
          :class="{ 'text-white bg-secondary-lightest': isActive.bold() }"
          @click="commands.bold"
        >
          <font-awesome-icon :icon="['far', 'bold']"/>
        </button>
        <button
          class="add-comment--style--icon"
          type="button"
          :class="{ 'text-white bg-secondary-lightest': isActive.italic() }"
          @click="commands.italic"
        >
          <font-awesome-icon :icon="['far', 'italic']"/>
        </button>
        <button
          class="add-comment--style--icon"
          type="button"
          :class="{ 'text-white bg-secondary-lightest': isActive.underline() }"
          @click="commands.underline"
        >
          <font-awesome-icon :icon="['far', 'underline']"/>
        </button>
      </div>
    </editor-menu-bar>
  </div>
</template>

<script>
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import {Bold, Italic, Underline} from 'tiptap-extensions';

export default {
  components: {
    EditorMenuBar,
    EditorContent,
  },
  props: {
    required: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    this.createEditor();
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    createEditor() {
      this.editor = new Editor({
        extensions: [
          new Bold(),
          new Italic(),
          new Underline(),
        ],
        onUpdate: ({getHTML}) => {
          const html = getHTML();
          this.$emit('input', html);
        },
      });

      if (this.value) {
        this.editor.setContent(this.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-comment {
  @apply px-8 pt-8;
  @screen md {
    @apply px-16;
  }
  &--style {
    @apply flex shadow-md;
    height: 30px;

    &--icon {
      @apply flex items-center px-3 text-sm h-full transition duration-300;
      &:nth-of-type(2) {
        @apply border-l border-r border-primary-medium;
      }

      &:hover {
        @apply text-white bg-secondary-lightest;
      }
    }
  }
}

/deep/ .ProseMirror-focused:focus {
  outline: none;
}
</style>
